import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';




// const logoBodyTemplate = (rowData) => <img src={rowData.logo} alt={rowData.name} style={{ width: 32, height: 32, borderRadius: '6px', objectFit: 'contain', background: '#fff', border: '1px solid #eee' }} />;

const InvoiceReports = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [data, setData] = useState();
    const [showDialog, setShowDialog] = useState(false);

      const dt = React.useRef(null);
   
      
       const exportCSV = () => {
           if (dt.current) {
               dt.current.exportCSV();
           }
       };
    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Invoice Portal</h3>
                <div className="flex gap-2">
                    <Calendar value={startDate} onChange={(e) => setStartDate(e.value)} placeholder="Start Date" dateFormat="yy-mm-dd" showIcon />
                    <Calendar value={endDate} onChange={(e) => setEndDate(e.value)} placeholder="End Date" dateFormat="yy-mm-dd" showIcon />
                    {/* <Button label="Add New" icon="pi pi-plus" className="p-button-success p-button-sm" onClick={() => setShowDialog(true)} /> */}
                </div>
            </div>
            <DataTable value={data} paginator rows={5} className="p-datatable-sm"
            footer={
                                <div className="flex justify-content-end">
                                    <Button label="Export CSV" icon="pi pi-download" className="p-button-info p-button-sm" onClick={exportCSV} />
                                </div>
                            }>
                <Column header="SL" body={(rowData, options) => options.rowIndex + 1} style={{ width: '60px' }} />

                <Column field="name" header="Merchant Name" />
                <Column field="status" header="Status" body={(rowData) => <span className={`badge ${rowData.status === 'Active' ? 'bg-success' : 'bg-secondary'}`}>{rowData.status}</span>} />
                <Column field="currency" header="Created Date" />
                <Column field="namespace" header="Phone Number" />
                <Column field="namespace" header="Total Invoice" />
                <Column field="namespace" header="Total Paid" />
                <Column field="namespace" header="Total Cancalled" />
                <Column field="namespace" header="Total Fee Charges" />
                <Column field="namespace" header="Total Reciepts" />

                <Column header="Action" body={() => <Button icon="pi pi-ellipsis-v" className="p-button-text p-button-sm" />} style={{ width: '80px' }} />
            </DataTable>
         
        </div>
    );
};

export default InvoiceReports;
